document.addEventListener("alpine:init", () => {
    Alpine.data("openable", () => ({
        open: false,
    }));
});

window.initFooterLinkColumns = () => {
    const footer = document.querySelector(".footer-container");
    const footerLinkColumns = footer.querySelectorAll(".footer-link-column");

    if (!footerLinkColumns || !footerLinkColumns.length) {
        return;
    }

    footerLinkColumns.forEach((column) => {
        const headings = column.querySelectorAll(".wp-block-heading");

        if (!headings || window.outerWidth > 767) {
            return;
        }

        const getLinkHeight = (group) => {
            const links = group.querySelectorAll("p");
            let height = 0;

            links.forEach((link) => {
                const style = window.getComputedStyle(link);
                height += link.offsetHeight;
                height += parseInt(style.marginBottom);
            });

            return height;
        };

        headings.forEach((heading) => {
            heading.addEventListener("click", (e) => {
                const group = heading.nextElementSibling;
                const height = getLinkHeight(group);

                console.log(height);

                if (heading.classList.contains("-open")) {
                    group.style.height = "0px";
                    heading.classList.remove("-open");
                } else {
                    group.style.height = height + "px";
                    heading.classList.add("-open");
                }
            });
        });
    });
};

window.onload = () => {
    window.initFooterLinkColumns();
};

window.addEventListener("message", function(event) {
    if (event.data.type === "hsFormCallback" && event.data.eventName === "onFormSubmitted") {
        const el = document.getElementById("form-success-trigger");
        const successUrl = el?.dataset?.successUrl;

        if (successUrl) {
            window.open(successUrl, "_blank");
        }
    }
});

document.addEventListener("alpine:init", () => {
    Alpine.data("tableOfContents", () => ({
        headings: {},

        init() {
            this.addIdsToHeadings();
            this.addAnchorsToLinks();
        },

        addIdsToHeadings() {
            const headings = document.querySelectorAll("article h2");

            headings.forEach((heading) => {
                let id = heading.innerText.toLowerCase().replace(/\s/g, "-");
                id = id.replace(/[^a-zA-Z0-9-]/g, "");
                heading.id = id;

                this.headings[id] = heading.innerText;
            });
        },

        addAnchorsToLinks() {
            const links = this.$root.querySelectorAll("a");

            Object.entries(this.headings).forEach(([id, text]) => {
                links.forEach((link) => {
                    if (link.innerText === text) {
                        link.href = `#${id}`;
                    }
                });
            });
        },
    }));
});
